import React, { Component } from 'react'
import { Button } from 'loyal-react'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'
import PropTypes from 'prop-types'
import yn from 'yn'

import TermsOption from './TermsOption'
import '@loyal_template/recharge.css'

class ResumeRecharge extends Component {
  render () {
    return (
      <div className='col-12 col-md-4 col-lg-4 border-ui-3 radius bg-white py-0 mt-2 mt-md-0 mb-auto'>
        <div className='row'>
          <div className='col-md-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom mb-1'>
            <h3 className='h3'>Resumo de recarga</h3>
          </div>
        </div>
        <div className='row'>
          <div className='col-12 pb-3 mx-0 px-3'>
            <div className='row product-brand py-1 border-dotted-bottom border-color-ui-3'>
              <div className='col-12 txt-body-sm txt-font-body color-ui-2 txt-left justify-content-center align-self-center'>
                Operadora: <strong>{this.props.operator}</strong>
              </div>
              <div className='col-12 txt-body-sm txt-font-body color-ui-2 txt-left justify-content-center align-self-center'>
                Telefone: <strong>{this.props.phoneNumber}</strong>
              </div>
              <div className='col-12 txt-body-sm txt-font-body color-ui-2 txt-left justify-content-center align-self-center'>
                Valor em créditos:{' '}
                <strong>
                  {this.props.creditValue ? `R$ ${this.props.creditValue.toLocaleString('pt-br', {
                    minimumFractionDigits: 2
                  })}` : ''}
                </strong>
              </div>
              <div className='col-12 txt-body-sm txt-font-body color-ui-2 txt-left justify-content-center align-self-center'>
                Valor em pontos:{' '}
                {this.props.pointsValue ? (
                  <CatalogCurrencyLabel value={this.props.pointsValue} />
                ) : (
                  ''
                )}
              </div>
            </div>
            <div className='row mt-2 mb-1 px-1'>
              <div className='col-12 px-0 txt-subtitle txt-font-body color-ui-2 txt-justify justify-content-center align-self-center'>
                O valor pode ser creditado em até 96 horas. Caso o valor não
                seja creditado nesse período, entre em contato com sua operadora
                de telefonia. A validade do crédito pode mudar para cada
                operadora.
              </div>
            </div>
            {yn(process.env.REACT_APP_HAS_OPTIN_REGULATION) && <TermsOption
              acceptedTerm={this.props.acceptedTerm}
              onChangeAcceptTerms={this.props.onChangeAcceptTerms}
              showTerms={this.props.showTerms}
            /> }
            <div className='cart-done row px-1 pt-2'>
              {this.props.scheduled ? (
                <div className='col-12 justify-content-center align-self-center px-0'>
                  <Button
                    className='btn-featured btn-icon'
                    text='Agendar recarga'
                    disabled={!this.props.acceptedTerm}
                    onClick={this.props.scheduleOrder}
                    loading={this.props.loadingScheduleOrder}
                  />
                </div>
              ) : (
                <div className='col-12 justify-content-center align-self-center px-0'>
                  <Button
                    className='btn-featured btn-gift'
                    text='Finalizar Recarga'
                    disabled={!this.props.acceptedTerm}
                    onClick={this.props.onRechargeConfirm}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ResumeRecharge.propTypes = {
  operator: PropTypes.string,
  phoneNumber: PropTypes.string,
  creditValue: PropTypes.number,
  pointsValue: PropTypes.number,
  scheduled: PropTypes.bool,
  acceptedTerm: PropTypes.bool,
  scheduleOrder: PropTypes.func,
  onRechargeConfirm: PropTypes.func,
  showTerms: PropTypes.func,
  onChangeAcceptTerms: PropTypes.func,
  loadingScheduleOrder: PropTypes.bool
}
export default ResumeRecharge



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/ResumeRecharge/ResumeRecharge.js